import { render, staticRenderFns } from "./kTomBuyTypeList.vue?vue&type=template&id=35041a6d&"
import script from "./kTomBuyTypeList.vue?vue&type=script&lang=js&"
export * from "./kTomBuyTypeList.vue?vue&type=script&lang=js&"
import style0 from "./kTomBuyTypeList.vue?vue&type=style&index=0&id=35041a6d&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports